import { hasValue } from '../general-helpers';

export const getImageSrc = (image) => {
    if (!hasValue(image)) {
        return undefined;
    }

    return image.src;
};
